import React, { type Ref, useEffect, useImperativeHandle, useRef } from "react";
import { GoogleMapsScriptUrl } from "../../useScript";
import "./SearchLocationInput.css";

export const loadScript = (url: string, callback: { (): void; (): void }) => {
    const scriptElements = Array.from(window.document.getElementsByTagName("script"));
    if (
        scriptElements.find((e) => {
            const src = e.getAttribute("src");
            return src && src === url;
        })
    ) {
        // script has already been loaded
        callback();
        return;
    }

    const script = document.createElement("script");
    script.type = "text/javascript";

    // @ts-expect-error
    if (script.readyState) {
        // @ts-expect-error
        script.onreadystatechange = function onReadyStateChange() {
            if (
                // @ts-expect-error
                script.readyState === "loaded" ||
                // @ts-expect-error
                script.readyState === "complete"
            ) {
                // @ts-expect-error
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {
        script.onload = () => {
            callback();
        };
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
};

type Properties = {
    placeListener: (place: google.maps.places.PlaceResult) => void;
    placeholder: string;
    className?: string;
    filterBy?: "cities";
    onBlur?: () => void;
    autofocus?: boolean;
};

// TODO only query fields that are needed
const SearchLocationInput = React.forwardRef(
    (props: Properties, ref: Ref<{ input: () => HTMLInputElement | null }>) => {
        let autoComplete: google.maps.places.Autocomplete;
        const {
            autofocus = false,
            className,
            filterBy,
            placeListener,
            placeholder,
            onBlur,
        } = props;
        const autoCompleteRef = useRef<HTMLInputElement>(null);

        // @ts-expect-error
        function handlePlaceSelect(updatePlace) {
            const addressObject = autoComplete.getPlace();
            updatePlace(addressObject);

            console.log(addressObject);
        }

        // @ts-expect-error
        function handleScriptLoad(updatePlace, inputRef, filter) {
            if (window.google) {
                autoComplete = new window.google.maps.places.Autocomplete(
                    inputRef.current,
                    filter ? { types: [`(${filter})`] } : undefined,
                );
                autoComplete.addListener("place_changed", () => {
                    handlePlaceSelect(updatePlace);
                });
            }

            if (autofocus) {
                autoCompleteRef.current?.focus();
            }
        }

        useImperativeHandle(ref, () => ({
            input: () => autoCompleteRef.current,
        }));

        useEffect(() => {
            loadScript(GoogleMapsScriptUrl, () => {
                handleScriptLoad(placeListener, autoCompleteRef, filterBy);
            });
        }, []);

        return (
            <div className="search-location-input">
                <input
                    className={className}
                    ref={autoCompleteRef}
                    placeholder={placeholder}
                    autoComplete="off"
                    onBlur={onBlur}
                />
            </div>
        );
    },
);

export default SearchLocationInput;
